import { CheckCircle, Clock, ErrorCircle, Settings } from '@ori-ui/icons';
import { colors } from '../constants';
import { SHADOW_LEVEL1 } from '../shadows';
import { jsx as _jsx } from "react/jsx-runtime";
const styleOverrides = {
  root: ({
    ownerState
  }) => ({
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: '1fr auto 1fr',
    opacity: 0.85,
    '& a': {
      fontWeight: 'bold'
    },
    '& a:hover': {
      color: colors.oriGrey[300]
    },
    ...(ownerState?.color === 'default' && ownerState?.variant === 'filled' && {
      backgroundColor: colors.commonColors.white,
      color: colors.text.primary,
      boxShadow: SHADOW_LEVEL1
    })
  }),
  icon: {
    justifySelf: 'end',
    marginTop: -3,
    marginBottom: -3,
    '& .MuiSvgIcon-root': {
      fontSize: 28
    }
  },
  message: {
    justifySelf: 'center'
  },
  action: {
    marginLeft: 0,
    justifySelf: 'end'
  }
};
const defaultProps = {
  variant: 'filled',
  iconMapping: {
    error: _jsx(ErrorCircle, {}),
    info: _jsx(Settings, {}),
    success: _jsx(CheckCircle, {}),
    warning: _jsx(Clock, {})
  }
};
export default {
  defaultProps,
  styleOverrides
};